export default {
  methods: {},
  bridgeReadyCallback: '',
  genteratecallbackName: function () {
    let timestamp = new Date().getTime();
    let globalCallbackName = 'sdkCallBack' + timestamp;
    return globalCallbackName;
  },
  gernerateNewCallback: function (callback, globalCallbackName) {
    return function () {
      let res = callback.apply(callback, arguments);
      delete window[globalCallbackName];
      return res;
    };
  },
  callSdkMethod: function (
    method: string,
    params?: object,
    callback?: Function
  ) {
    if (typeof params == 'function') {
      callback = params;
      params = {};
    }

    if (typeof window !== 'undefined' && typeof callback === 'function') {
      let globalCallbackName = this.genteratecallbackName();
      while (window[globalCallbackName]) {
        globalCallbackName = this.genteratecallbackName();
      }
      // 全局声明一个临时函数地址，地址指向回调函数。执行回调之后，会自动删除这个全局函数。
      window[globalCallbackName] = this.gernerateNewCallback(
        callback,
        globalCallbackName
      );
      params['callback'] = globalCallbackName;
    }
    let paramsStr = JSON.stringify(params);

    // andoid
    if (
      typeof window !== 'undefined' &&
      window.sdkCtrl &&
      typeof window.sdkCtrl.callSDKMethodWithParameters == 'function'
    ) {
      window.sdkCtrl.callSDKMethodWithParameters(method, paramsStr);
    }

    // ios
    else if (
      typeof window !== 'undefined' &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.callSDKMethodWithParameters
    ) {
      window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
        method,
        params,
      });
    }
  },

  runInsdk() {
    let runInAndroid =
      typeof window !== 'undefined' &&
      window.sdkCtrl &&
      typeof window.sdkCtrl.callSDKMethodWithParameters == 'function';
    let runInIOS =
      typeof window !== 'undefined' &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.callSDKMethodWithParameters;
    return runInAndroid || runInIOS;
  },

  createReadyEvent: function () {
    if (
      typeof window !== 'undefined' &&
      typeof this.bridgeReadyCallback === 'function'
    ) {
      // 原生app 在装载页面成功后，触发 window.triggerBridgeReady 告诉前端，前端可以调用原声的方法.
      window.triggerBridgeReady = function () {
        this.bridgeReadyCallback();
      }.bind(this);
    }
  },
  listendRendy: function (callback) {
    this.bridgeReadyCallback = callback;
    if (typeof window.triggerBridgeReady != 'function') {
      this.createReadyEvent();
    }
  },
  injectObjFinish() {
    let androidSuccess =
      window &&
      window.sdkCtrl &&
      typeof window.sdkCtrl.callSDKMethodWithParameters == 'function';
    let iosSuccesss =
      typeof window !== 'undefined' &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.callSDKMethodWithParameters;
    return androidSuccess || iosSuccesss;
  },
  onReady(callback) {
    if (this.injectObjFinish()) {
      if (typeof callback == 'function') {
        callback(this);
      }
    } else {
      this.listendRendy(callback);
    }
  },
  callJavascriptMethod(method, paramsStr) {
    let params = {};
    if (paramsStr) {
      params = JSON.parse(paramsStr);
    }
    // 构造回调函数
    let callback = function () {
      let callbackMethodName = params['callback'];
      if (params['callback']) {
        let ars = Array.prototype.slice.call(arguments, 0);
        ars.unshift(callbackMethodName);
        this.callSdkMethod.apply(this, ars);
      }
    };
    if (typeof this.methods[method] === 'function') {
      this.methods[method](params, callback);
    }
  },
  registHandler(methodName, handler) {
    if (
      typeof window !== 'undefined' &&
      window.callJavascriptMethod === undefined
    ) {
      window.callJavascriptMethod = this.callJavascriptMethod.bind(this);
    }
    // 不能重复注册，覆盖了其他函数
    if (typeof this.methods[methodName] === 'function') {
      throw new Error(
        `MethodsName '${methodName}' was registed ,plz change another`
      );
    }
    // 注册时必须有函数实体
    if (typeof handler !== 'function') {
      throw new Error('The second argument must be a callback function');
    }
    this.methods[methodName] = handler;
  },
};
